import VueClipboard from 'vue-clipboard2';
import Vue from "vue";

Vue.use(VueClipboard);


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/clipboard.js